import * as React from 'react';
import createSvgIcon from '../utils/createSvgIcon';

const Box = createSvgIcon(
  <path d="M0 0v7.5h1.5V24h21V7.5H24V0H0Zm9.75 2.25h4.5v5.213L12 6.213l-2.25 1.25V2.25ZM16.5 7.5h3.75v14.25H3.75V7.5H7.5v3.787l4.5-2.5 4.5 2.5V7.5Zm-9-2.25H2.25v-3H7.5v3Zm9-3h5.25v3H16.5v-3Z" />,
  'Box'
);

export { Box };